var _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCotizar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "pl",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "pl__ring pl__ring--a",
    cx: 120,
    cy: 120,
    r: 105,
    fill: "none",
    stroke: "#000",
    strokeWidth: 20,
    strokeDasharray: "0 660",
    strokeDashoffset: -330,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "pl__ring pl__ring--b",
    cx: 120,
    cy: 120,
    r: 35,
    fill: "none",
    stroke: "#000",
    strokeWidth: 20,
    strokeDasharray: "0 220",
    strokeDashoffset: -110,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "pl__ring pl__ring--c",
    cx: 85,
    cy: 120,
    r: 70,
    fill: "none",
    stroke: "#000",
    strokeWidth: 20,
    strokeDasharray: "0 440",
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "pl__ring pl__ring--d",
    cx: 155,
    cy: 120,
    r: 70,
    fill: "none",
    stroke: "#000",
    strokeWidth: 20,
    strokeDasharray: "0 440",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCotizar);
export default __webpack_public_path__ + "static/media/Cotizar.055208115d192ca5153eaec66c8ac607.svg";
export { ForwardRef as ReactComponent };